import { CSSObject, SerializedStyles } from '@emotion/react';

import { useTheme } from '@reckon-web/theme';

const GenericBlock: React.FC<{
  maxWidth?: number;
  paddingX?: number;
  testId?: string;
  children?: React.ReactNode;
}> = ({
  maxWidth,
  paddingX,
  children,
  testId = 'generic-block',
  ...restProps
}) => (
  <div data-testid={testId} {...restProps}>
    <div
      css={{
        margin: '0 auto',
        width: '100%',
        minWidth: '0',
        maxWidth,
        padding: paddingX && `0 ${paddingX}px`,
      }}
    >
      {children}
    </div>
  </div>
);

export const Block: React.FC<{
  size?: 'narrow' | 'wide';
  testId?: string;
  children?: React.ReactNode;
  css?: CSSObject | SerializedStyles;
}> = ({ size, testId = 'block', ...restProps }) => (
  <GenericBlock
    maxWidth={size === 'narrow' ? 960 : 1680}
    paddingX={useTheme().spacing.xxlarge}
    testId={testId}
    {...restProps}
  />
);
